'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Label = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(LabelPrimitive.Root, _objectSpread({
    ref: ref,
    className: cn('tw-text-neutral-light-800 tw-text-1.4 tw-font-semibold dark:tw-text-neutral-light-100', className)
  }, props));
});
Label.displayName = LabelPrimitive.Root.displayName;
export { Label };